import React, {useState} from 'react';
import './destiny-free-sample.scss';
import RadioMarkCard from "../../../shared/components/molecules/radio-mark-card/radio-mark-card";


const DestinyFreeSample = ({ recipientS, label, labelButton, handleAction, selectDestinySample, canAdd }) => {
    const [currentUserTypeId, setcurrentUserTypeId] = useState("")
    // console.log({recipientS})
    return(
        <div className="f-destiny" >
            <div className="f-destiny-content">
                <h3 className="f-destiny-title" >{label}</h3>
                <div className="f-destiny-content-radio">
                {recipientS.map((value, index) => {
                    return <React.Fragment key={index}>
                    <RadioMarkCard
                      title={value.tipoDeUsuarioUsuarioTitulo}
                      description={value.tipoDeUsuarioUsuarioDescripcion}
                      image={value.tipoDeUsuarioUsuarioImagen}
                      isActive={currentUserTypeId === value.tipoDeUsuarioUsuarioId}
                      setActive={() => { setcurrentUserTypeId(currentUserTypeId === value.tipoDeUsuarioUsuarioId ? "" : value.tipoDeUsuarioUsuarioId); selectDestinySample(value.tipoDeUsuarioIdMuestras) }}
                    />
                  </React.Fragment>
                })}
                </div>
                {/* <RadioGroup className="f-destiny-radiogroup" onChange={ value => selectDestinySample(value.target.value) } >
                    {recipients.map( (value, key) =>
                        <div className="f-destiny-template-radio" key={key}  >
                            <Radio className='f-destiny-radio' name={`${key}`} id={`${key}`} key={key}  value={value} />
                            <label className='f-destiny-radio-label' htmlFor={`${key}`} >{value}</label>
                        </div> 
                        
                    )}
                </RadioGroup> */}
            </div>
            <div className="f-destiny-buttons" >
                <button className="f-destiny-button" disabled={!canAdd} onClick={handleAction} >{labelButton}</button>    
            </div>
        </div>
    )
}

export default DestinyFreeSample;